import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },

    header: {
      margin: theme.spacing(3, 2, 0.75),
    },
    spacer: {
      flex: '1',

      '@media screen and (max-height: 664px)': {
        minHeight: theme.spacing(3),
      },
    },
    item: {
      '& + &': {
        marginTop: theme.spacing(0.75),
      },
      '&:last-child': {},
    },
  }),
  { name: 'SidebarItems' }
);
